import React from 'react'
import { Outlet,  } from 'react-router-dom'

export default function Main({ActiveShope,HandleActiveShope,userData,setUserData}) {
  return (
    <div className='mainChat' >
       
       <Outlet/>
      
    </div>
  )
}
